(function () {
    'use strict';

    angular
        .module('rms.common')
        .filter('objectSummary', objectSummary);

    function objectSummary(lodash, RmsEnum, $q) {
        return function(value, options) {
            if (typeof options === typeof undefined) {
                return '';
            }

            const fields = lodash.get(options, 'fields', []);
            const enumsFields = lodash.get(options, 'enum_fields', {});

            const delimiter = lodash.get(options, 'delimiter', ', ');
            if (!(fields instanceof Array)) {
                return '';
            }
            return fields.reduce(function(result, field) {
                let val = lodash.get(value, field, '').toString();

                if (lodash.isEmpty(val)) {
                    return result;
                }

                if (lodash.has(enumsFields,field)) {
                    val = RmsEnum.get(enumsFields[field], val, '');
                }

                if (lodash.isEmpty(result)) {
                    return val;
                }
                return [result, val].join(delimiter);
            }, '');
        };
    }
})();